import { filter, reduce } from "lodash";
import { create } from "zustand";

import { Song } from "../types/song.types";

interface LikedSongsStore {
  songs: object;
  setSongs: (songs: Song[]) => void;
  addSong: (songId: string) => void;
  deleteSong: (songId: string) => void;
}

const likedSongsStore = create<LikedSongsStore>((set) => ({
  songs: new Set<Song>(),
  setSongs: (songs: Song[]) => {
    const objectToStore = reduce(
      songs,
      (acc, song) => ({
        ...acc,
        [song.id]: true,
      }),
      {}
    );
    set({ songs: objectToStore });
  },
  addSong: (songId: string) => {
    set((state) => {
      const updatedObject = { ...state.songs, [songId]: true };
      return { songs: updatedObject };
    });
  },
  deleteSong: (songId: string) => {
    set((state) => {
      const updatedObject = { ...state.songs, [songId]: false };
      return { songs: updatedObject };
    });
  },
}));

export default likedSongsStore;
